// src/config.js
const config = {
    SITE_URL: process.env.REACT_APP_SITE_URL,
    API_URL: process.env.REACT_APP_API_URL,
    WP_API_URL: process.env.REACT_APP_WP_API_URL,
};

export default config;
